<template>
  <div :key="'detailInvoiceProductsCompoundTable_' + forceUpdate" class="crud-detail-product-fieldset">
    <b-row class="detail-product-compound-form" :class="[{'block-product-add':crud.form.detail_register.editing}]">
      <b-col :lg="7 + widthShowDiscount" :md="7 + widthShowDiscount">
        <b-row>
          <b-col lg="6" md="6" id="container_detail_product_compound_select">
            <FindObject :key="crud.form.detail_register.forceRenderSelectProduct"
                        render="search"
                        type="productsCompound" 
                        @select-object="loadProductsCompound($event, true)"
                        :valueID="crud.form.detail_register.productCompound_id"
                        :where="conditionProductsCompoundActive"                        
                        id="detail_product_compound_select" /> 

            <b-popover target="detail_product_compound_select"
                       triggers="hover"
                       placement="auto"
                       container="container_detail_product_compound_select"
                       v-if="crud.form.detail_register.productCompound">
              <template #title><AppIcon name="box" class="mr-1" />Stock</template>
              <div class="detail-product-popover-list">
                <div class="detail-product-popover-list__row">
                  <span class="detail-product-popover-list__label">Depósito</span>
                  <span class="detail-product-popover-list__value">{{parseFloat(this.crud.form.detail_register.productCompound.stock).toFixed(2)}} {{this.crud.form.detail_register.productCompound.unit_measurement.reference}}</span>
                </div>
                <div class="detail-product-popover-list__row">
                  <span class="detail-product-popover-list__label">Pendiente</span>
                  <span class="detail-product-popover-list__value">{{parseFloat(this.crud.form.detail_register.productCompound.stock_pending).toFixed(2)}} {{this.crud.form.detail_register.productCompound.unit_measurement.reference}}</span>
                </div>
              </div>
            </b-popover>
          </b-col>              
        </b-row>
      </b-col>
      <b-col :lg="5 - widthShowDiscount" :md="5 - widthShowDiscount" class="detail-product-compound-pricing-fields">
        <b-row>
          
          <b-col :lg="3 + widthShowDiscount" :md="3 + widthShowDiscount">
            <b-form-group label="Cantidad">                                                                 
              <app-text-input v-model="crud.form.detail_register.quantity"
                              ref="inputQuantity"
                              type="number"
                              min="0"
                              step="1"
                              class="form-control"
                              size="sm"/>
            </b-form-group>
          </b-col>                   

          <b-col :lg="4 + widthShowDiscount" :md="4 + widthShowDiscount" class="pl-md-0 pr-md-0">

            <div  v-if="crud.form.detail_register.unit_measurement">                  
              <b-form-group label="Importe" v-if="crud.form.detail_register.currency"> 
                <b-input-group :prepend="crud.form.detail_register.currency.symbol" size="sm" class="crud-detail-product-prepend-amount">
                  <app-number-input :key="crud.form.detail_register.forceRenderPrice" v-model="crud.form.detail_register.amount"
                                    size="sm"
                                    :disabled="!editPrice"
                                    min="0"
                                    class="form-control" />

                  <template #append>
                    <b-button v-if="crud.form.detail_register.unit_measurement" size="sm" variant="secondary" class="curd-detail-product-select-unit-measurement" :text="crud.form.detail_register.unit_measurement.reference">
                      {{crud.form.detail_register.unit_measurement.reference}} 
                    </b-button>
                  </template>                            
                </b-input-group>
              </b-form-group>
              <b-form-group label="Importe" v-else size="sm"> 
                <b-input-group prepend="$" size="sm" class="crud-detail-product-prepend-amount">
                  <app-number-input :key="crud.form.detail_register.forceRenderPrice" v-model="crud.form.detail_register.amount"
                                    size="sm"
                                    :disabled="!editPrice"
                                    min="0"
                                    class="form-control" />

                    <template #append>
                      <b-button v-if="crud.form.detail_register.unit_measurement" size="sm" variant="secondary" class="curd-detail-product-select-unit-measurement" :text="crud.form.detail_register.unit_measurement.reference">
                        {{crud.form.detail_register.unit_measurement.reference}} 
                      </b-button>
                    </template>                                               
                </b-input-group>
              </b-form-group>  
            </div>
            <div v-else>
              <b-form-group label="Importe" v-if="crud.form.detail_register.currency"> 
                <b-input-group :prepend="crud.form.detail_register.currency.symbol" size="sm" class="crud-detail-product-prepend-amount">
                  <app-number-input :key="crud.form.detail_register.forceRenderPrice" v-model="crud.form.detail_register.amount"
                                    size="sm"
                                    :disabled="!editPrice"
                                    min="0"
                                    class="form-control" />
                </b-input-group>
              </b-form-group>
              <b-form-group label="Importe" v-else size="sm"> 
                <b-input-group prepend="$" size="sm" class="crud-detail-product-prepend-amount">
                  <app-number-input :key="crud.form.detail_register.forceRenderPrice" v-model="crud.form.detail_register.amount"
                                    size="sm"
                                    :disabled="!editPrice"
                                    min="0"
                                    class="form-control" />
                </b-input-group>
              </b-form-group> 
            </div>                         
          </b-col>

          <b-col lg="3" md="3" v-if="showDiscount">
            <b-form-group label="Descuento">                         
              <b-input-group append="%" size="sm" class="crud-detail-product-append-discount">
                <app-text-input v-model="crud.form.detail_register.discount"
                                type="number"
                                min="0"
                                max="100"
                                step="1"
                                class="form-control"
                                size="sm"/>
              </b-input-group>
            </b-form-group>              
          </b-col>        

          <b-col lg="1" md="1" class="crud-new-orders-button-add">
            <b-button @click="addItem()" 
                      v-b-tooltip.hover 
                      :variant="crud.form.detail_register.button.variant"
                      :title="crud.form.detail_register.button.title"
                      size="sm">
              <i :class="crud.form.detail_register.button.icon"></i>
            </b-button>                                                    
          </b-col>
        </b-row>
      </b-col>
      <b-col lg="12" v-if="crud.form.detail_register.editing" class="block-product-add-div">
        <b-icon icon="circle-fill" animation="throb" font-scale="2"></b-icon>
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col md="12">                  
        <b-table  class="mb-0 app-table app-table--compact crud-order-table-detail"
                  responsive="sm"
                  :stacked="isMobileViewport ? 'md' : false"
                  :hover="true"
                  :small="true"
                  :fixed="true"
                  :items="crud.form.detail"
                  :fields="tableDetailNewOrder">

          <template v-slot:table-colgroup="scope">
            <col
              v-for="field in scope.fields"
              :key="field.key"
              :style="{ width: field.width }"
            >
          </template>

          <template v-slot:cell(code)="data">
            {{data.item.productCompound.code}}
          </template>

          <template v-slot:cell(product)="data">
            <div :class="isMobileViewport ? 'text-wrap' : 'text-truncate'" v-b-tooltip.hover :title="data.item.productCompound.name">
              {{data.item.productCompound.name}}
            </div>
          </template>

          <template v-slot:cell(list)="data">     
            <span v-if="data.item.price_list">
              {{data.item.price_list.reference}}
            </span>
          </template>   

          <template v-slot:cell(quantity)="data">                            
            {{ parseFloat(data.item.quantity).toFixed(2) }} 
            <span v-if="data.item.unit_measurement">{{data.item.unit_measurement.reference}}</span>
          </template>   

          <template v-slot:cell(amount)="data">  
            {{formatDetailNetPrice(data.item, data.item.amount)}}
          </template>   

          <template v-slot:cell(amount_iva)="data">
            {{formatDetailPrice(data.item, data.item.amount)}}
          </template>   

          <template v-slot:cell(discount)="data">  
            <span :id="'detail-product-compound-discount-info-' + data.index"
                  class="detail-discount-rate"
                  :class="{ 'detail-discount-rate--info': !notIva && hasDetailItemIva(data.item) }"
                  :tabindex="!notIva && hasDetailItemIva(data.item) ? 0 : null">{{data.item.discount}}%</span>
            {{notIva ? formatDetailNetPrice(data.item, getRegDiscount(data.item)) : formatDetailPrice(data.item, getRegDiscount(data.item))}}
            <b-popover v-if="!notIva && hasDetailItemIva(data.item)"
                       :target="'detail-product-compound-discount-info-' + data.index"
                       triggers="click blur"
                       placement="bottom"
                       custom-class="detail-discount-popover">
              <div class="detail-discount-popover__row"><span>Lista</span><strong>{{data.item.price_list ? data.item.price_list.reference : '-'}}</strong></div>
              <div class="detail-discount-popover__section">
                <div class="detail-discount-popover__row"><span>Importe unitario</span><strong>{{formatDetailNetPrice(data.item, data.item.amount)}}</strong></div>
                <div class="detail-discount-popover__row"><span>IVA <small class="detail-discount-popover__iva">{{parseFloat(getDetailItemAliquotIva(data.item) || 0).toFixed(2)}}%</small></span><strong>{{formatDetailNetPrice(data.item, getDetailIvaAmount(data.item))}}</strong></div>
                <div class="detail-discount-popover__row"><span>Precio unit. c/IVA</span><strong>{{formatDetailPrice(data.item, data.item.amount)}}</strong></div>
                <div class="detail-discount-popover__row"><span>Descuento <small class="detail-discount-popover__iva">{{parseFloat(data.item.discount || 0).toFixed(2)}}%</small></span><strong>{{formatDetailPrice(data.item, getDetailUnitDiscount(data.item))}}</strong></div>
                <div class="detail-discount-popover__row" v-if="parseFloat(data.item.discount) > 0"><span>Precio unit. final</span><strong>{{formatDetailPrice(data.item, getDetailUnitFinal(data.item))}}</strong></div>
                <div class="detail-discount-popover__row"><span>Cantidad</span><strong>{{getDetailQuantityLabel(data.item)}}</strong></div>
                <div class="detail-discount-popover__row"><span>Total final</span><strong>{{formatDetailPrice(data.item, getRegTotals(data.item))}}</strong></div>
              </div>
            </b-popover>
          </template>   
          
          <template v-slot:cell(total)="data">  
            {{notIva ? formatDetailNetPrice(data.item, getRegTotals(data.item)) : formatDetailPrice(data.item, getRegTotals(data.item))}}
          </template>   

          <template v-slot:cell(f_action)="data">  
            <b-dropdown right no-caret
                        size="sm"
                        variant="link"
                        boundary="window"
                        toggle-class="app-table-action-toggle"
                        :disabled="crud.form.detail_register.button.editing">
              <template #button-content><AppIcon name="more_vert" :label="isMobileViewport ? 'Opciones' : 'Acciones'" /><span v-if="isMobileViewport" class="app-table-action-label">Opciones</span></template>
              <b-dropdown-header>Acciones</b-dropdown-header>
              <b-dropdown-item @click="editItem(data.item, data.index)">
                <AppIcon name="edit" /> Editar
              </b-dropdown-item>
              <b-dropdown-item @click="deleteItem(data.index)">
                <AppIcon name="delete" class="text-danger" /> Eliminar
              </b-dropdown-item>     
            </b-dropdown>                                
          </template>                    
        </b-table>                  
      </b-col>
    </b-row> 

    <!-- ########################### -->
    <!-- #####     MODALES     ##### -->
    <!-- ########################### -->

    <!-- CRUD MULTIPLE LIST PRICE -->
    <b-modal v-model="modal.multipleListPrice.active"
            size="lg"
            no-close-on-esc
            no-close-on-backdrop
            hide-header-close
            @shown="focusFirstMultipleListPriceAction"
            @hidden="onMultipleListPriceHidden">
      <div slot="modal-header" class="app-modal-header"><span class="app-modal-header__icon"><AppIcon name="payments" /></span><h5 class="app-modal-header__title">{{ modal.multipleListPrice.title }}</h5></div>

      <div class="app-modal-detail-list mb-3">
        <div class="app-modal-detail-list__row"><span class="app-modal-detail-list__label">Producto</span><span class="app-modal-detail-list__value"><b>{{ modal.multipleListPrice.product }}</b></span></div>
        <div class="app-modal-detail-list__row"><span class="app-modal-detail-list__label">Código</span><span class="app-modal-detail-list__value">{{ modal.multipleListPrice.code }}</span></div>
      </div>
      <b-row>
        <b-col lg="12">          
          <b-table 
            class="app-table app-table--compact mb-0"
            responsive="sm"
            :stacked="isMobileViewport ? 'md' : false"
            :hover="true"
            :fixed="false"
            :items="tableMultipleListPrice.items"
            :fields="tableMultipleListPrice.fields"
            :tbody-tr-class="multipleListPriceRowClass">
            
            <template v-slot:cell(list)="data">  
              <div v-if="data.item.list">
                {{data.item.list.reference}}
              </div>
            </template>  

            <template v-slot:cell(price)="data">                
              <div v-if="data.item && data.item.list && data.item.list.currency">
                {{Intl.NumberFormat('es-AR',{style:'currency',currency:data.item.list.currency.code}).format(data.item.price_simple)}}
              </div>
            </template>

            <template v-slot:cell(action)="data">  
              <b-button variant="primary"
                        size="sm"
                        :class="['find-btn-select', 'multiple-list-price-select-btn', { 'find-btn-select--mobile': isMobileViewport }]"
                        title="Seleccionar lista de precios"
                        @click="selectMultipleListPrice(data.item)"
                        @focus="multipleListPriceActiveIndex = data.index"
                        :disabled="multipleListPriceSelecting"
                        :ref="'actionPriceItem_' + data.index">
                <AppIcon name="arrow_circle_right" label="Seleccionar lista de precios" /> <span v-if="isMobileViewport">Seleccionar</span>
              </b-button>
            </template>                          
          </b-table>
        </b-col>
      </b-row>

      <div slot="modal-footer">
        <b-button variant="outline-secondary" size="sm" @click="cancelMultipleListPrice()">Cancelar</b-button>
      </div>
    </b-modal>   

  </div>       
</template>

<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import ErrorToken from '@/handler/errorToken'
  import Session from '@/handler/session'  
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper' 
  import FindObject from '@/components/inc/find/findObject'    
  import Param from '@/config/parameters'
  import moment from 'moment'

  export default {
    props: {
      customer_id:{
        type: Number,
        required: true,
      },
      price_list_id:{
        type: Number,
        default: 0,
      },
      disableCustomerPriceListFallback: {
        type: Boolean,
        default: false,
      },
      editPrice: {
        type: Boolean,
        default: false,
      },
      validStock: {
        type: Boolean,
        default: false,
      },
      detailEdit: {
        type: [Array, Object],
        default: null,
      },
      showDiscount: {
        type: Boolean,
        default: true,        
      },
      forceUpdate: {
        type: Number,
        default: 0,
      },     
      validItemDuplicated: {
        type: Boolean,
        default: true,
      },
      ivaConditions: {
        type: Array,
        default: () => [],
      },
      notIva: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      FindObject,
    },
    data: () => {
      return {  
        tableDetailNewOrder : [],    
        tableMultipleListPrice : {
          items: [],
          fields: [],
        },
        multipleListPriceActiveIndex: -1,
        multipleListPriceSelecting: false,
        crud: {
          form: {
            detail_register: {
              quantity: 0,
              quantityOld: 0,
              amount: 0,
              discount: 0,
              currency: null,              
              productCompound_id: 0,
              productCompound: null,     
              forceRenderSelectProduct: 0,
              forceRenderPrice: 0,
              unit_measurement: null,
              unit_measurement_id: 0,
              amount_initial: 0,
              price_list_id: 0,
              price_list: null,              
              button: {
                icon: 'fa fa-plus',
                title: 'Agreagr Item',
                variant: 'success',
                editing: false
              },
              editing: false,
            },            
            detail: [],   
            editOrder: false,    
          },               
        },
        editing: {
          status: false,
          price: 0,
          unit_measurement: null,
        },     
        modal: {
          multipleListPrice: {
            active: false,
            title: '',
            code: '',
            product: '',
          },
        },
        isMobileViewport: false,
      }
    },
    watch: {
      isMobileViewport() {
        this.configFieldsTable()
      },
      notIva() {
        this.configFieldsTable()
      },
      'crud.form.detail_register.productCompound': function (newQuestion, oldQuestion) {
        if(newQuestion) {          
          if(!(this.editPrice && this.editing.status)) {          
            if(this.customer_id) {                    
              var result = serviceAPI.obtenerPrecioProductoCompuesto({
                products_compound: newQuestion,
                customer_id: this.customer_id,
                price_list_id: this.price_list_id,
                disable_customer_price_list_fallback: this.disableCustomerPriceListFallback
              })        
              result.then((response) => {
                var data = response.data   

                this.tableMultipleListPrice.items = data
                
                if (Array.isArray(data)) {              
                  this.modal.multipleListPrice.title = "Selección de Lista de Precios"
                  this.modal.multipleListPrice.code = newQuestion.code
                  this.modal.multipleListPrice.product = newQuestion.name
                  this.modal.multipleListPrice.active = true                                    
                } else {                  
                  this.crud.form.detail_register.currency= data.list.currency 
                  this.crud.form.detail_register.amount = data.price_simple   
                  this.crud.form.detail_register.amount_initial = data.price_simple      
                  
                  if(data.list) {
                    this.crud.form.detail_register.price_list_id = data.list.id
                    this.crud.form.detail_register.price_list = data.list                  
                  }                  
                }                         
              })             
            }                 

            if(newQuestion.unit_measurement) {
              this.crud.form.detail_register.unit_measurement = newQuestion.unit_measurement
              this.crud.form.detail_register.unit_measurement_id = newQuestion.unit_measurement.id
            }
          }                            

          this.editing.status = false
          this.editing.price = 0
          this.editing.unit_measurement = null      
        }                
      },
    },  
    computed: {    
      // CONDITIONS SELECT  
      conditionProductsCompoundActive() {
        return [{field: 'active', condition: true}];
      },    

      // CONFIGURATION SHOW DISCOUNT    
      widthShowDiscount () {
        if(this.showDiscount) {
          return 0
        } else {
          return 1
        }
      },

      // MODULES ACTIVES
      moduleDepositActive() {
        var status = false
        var modules = Session.getSession().auth.user.permissions.modules
        modules.forEach(element => {
          if(element.id == Modules.DEPOSITOS) {
            status = true
          }
        })
        return status
      },            
    },
    created() {
      window.addEventListener('keydown', this.handleMultipleListPriceKeydown)
    },
    mounted() {
      this.mobileMql = window.matchMedia('(max-width: 767.98px)')
      this.isMobileViewport = this.mobileMql.matches
      this.mobileMql.addEventListener('change', this.updateMobileViewport)

      this.configFieldsTable()
      this.loadItems()
    },
    beforeDestroy() {
      window.removeEventListener('keydown', this.handleMultipleListPriceKeydown)
      if(this.mobileMql) {
        this.mobileMql.removeEventListener('change', this.updateMobileViewport)
      }
    },
    methods: {
      updateMobileViewport(e) {
        this.isMobileViewport = e.matches
      },
      alignClass(desktopClass) {
        return this.isMobileViewport ? 'text-left' : desktopClass
      },
      getMultipleListPriceAction(index) {
        var action = this.$refs['actionPriceItem_' + index]
        return Array.isArray(action) ? action[0] : action
      },
      focusMultipleListPriceAction(index) {
        var action = this.getMultipleListPriceAction(index)
        if(!action || typeof action.focus !== 'function') return
        this.multipleListPriceActiveIndex = index
        action.focus()
      },
      focusFirstMultipleListPriceAction() {
        this.$nextTick(() => this.focusMultipleListPriceAction(0))
      },
      onMultipleListPriceHidden() {
        this.multipleListPriceActiveIndex = -1
        this.multipleListPriceSelecting = false
      },
      multipleListPriceRowClass(item, type) {
        return type === 'row' && item === this.tableMultipleListPrice.items[this.multipleListPriceActiveIndex]
          ? 'app-table-row-active'
          : ''
      },
      handleMultipleListPriceKeydown(event) {
        if(!this.modal.multipleListPrice.active || (event.key !== 'ArrowDown' && event.key !== 'ArrowUp')) return

        var activeIndex = this.tableMultipleListPrice.items.findIndex((item, index) => {
          var action = this.getMultipleListPriceAction(index)
          var element = action && (action.$el || action)
          return element === document.activeElement
        })
        var currentIndex = activeIndex === -1 ? this.multipleListPriceActiveIndex : activeIndex
        if(currentIndex < 0) currentIndex = 0

        var nextIndex = event.key === 'ArrowDown'
          ? Math.min(currentIndex + 1, this.tableMultipleListPrice.items.length - 1)
          : Math.max(currentIndex - 1, 0)

        event.preventDefault()
        this.focusMultipleListPriceAction(nextIndex)
      },
      configFieldsTable() {
        // TABLE DETAILS
        this.tableDetailNewOrder = []
        this.tableDetailNewOrder.push({key: 'code', label: 'Código', class:"align-middle text-truncate", width:"115px"})
        this.tableDetailNewOrder.push({key: 'product', label: 'Producto', class:"align-middle"})
        this.tableDetailNewOrder.push({key: 'list', label: 'Lista', class:"align-middle " + this.alignClass('text-center'), width:"70px"})
        this.tableDetailNewOrder.push({key: 'quantity', label: 'Cantidad', class:"align-middle " + this.alignClass('text-center'), width:"90px"})
        this.tableDetailNewOrder.push({key: 'amount', label: 'Importe', class:"align-middle " + this.alignClass('text-right'), width:"115px"})
        if(!this.notIva) {
          this.tableDetailNewOrder.push({key: 'amount_iva', label: 'Importe c/IVA', class:"align-middle " + this.alignClass('text-right'), width:"130px"})
        }

        if(this.showDiscount) {
          this.tableDetailNewOrder.push({key: 'discount', label: 'Descuento', class:"align-middle " + this.alignClass('text-right'), width:"140px"})
        }

        this.tableDetailNewOrder.push({key: 'total', label: 'Total', class:"align-middle " + this.alignClass('text-right'), width:"125px"})
        this.tableDetailNewOrder.push({key: 'f_action', label: this.isMobileViewport ? 'Acción' : '', class:"align-middle " + this.alignClass('text-right'), width:"50px"})

        // TABLE MULTIPLE PRICE
        this.tableMultipleListPrice.fields = []
        this.tableMultipleListPrice.fields.push({key: 'list', label: 'Lista', class:"align-middle"})
        this.tableMultipleListPrice.fields.push({key: 'price', label: 'Precio', class:"align-middle " + this.alignClass('text-right')})
        this.tableMultipleListPrice.fields.push({key: 'action', label: this.isMobileViewport ? 'Acción' : '', class:"align-middle " + this.alignClass('text-right')})
      },
      loadItems() {              
        if(this.detailEdit) {
          this.detailEdit.forEach(element => {         
            var arrItem = { 
              productCompound: element.productCompound, 
              quantity: parseFloat(element.quantity), 
              quantityOld: parseFloat(element.quantity),
              currency: element.currency,                        
              amount: parseFloat(element.amount),   
              discount: (element.itemDetail ? parseFloat(element.itemDetail.percentage_discount) : 0),                       
              unit_measurement: element.unit_measurement,
              price_list: element.price_list
            }

            this.crud.form.detail.push(arrItem)                  
            this.crud.form.editOrder = true
          });
          
          this.$emit('load-detail', this.crud.form.detail)
        }
      },      
      focusQuantity() {
        var input = this.$refs.inputQuantity
        if(!input || typeof input.focus !== 'function') return
        input.focus()
        if(typeof input.select === 'function') input.select()
      },
      loadProductsCompound (object, focusAfterSelection = false) {
        if(object){
          this.crud.form.detail_register.productCompound = object
          this.crud.form.detail_register.productCompound_id = object.id     
                    
          this.crud.form.detail_register.forceRenderSelectProduct = object.id                  
          if(focusAfterSelection) {
            this.$nextTick(() => this.focusQuantity())
          }
        } else {                    
          this.crud.form.detail_register.productCompound = null
          this.crud.form.detail_register.productCompound_id = 0                            
          
          this.crud.form.detail_register.quantity = 0          
          this.crud.form.detail_register.amount = 0  
          this.crud.form.detail_register.discount = 0
          this.crud.form.detail_register.currency = null  
          this.crud.form.detail_register.unit_measurement = null
          this.crud.form.detail_register.unit_measurement_id = 0

          this.crud.form.detail_register.button.title = "Agregar Item"
          this.crud.form.detail_register.button.icon = "fa fa-plus"
          this.crud.form.detail_register.button.variant = "success"          
        }
      },    

      // MULTIPLE LIST PRICE
      selectMultipleListPrice(item) {
        if(this.multipleListPriceSelecting) return
        this.multipleListPriceSelecting = true
        this.crud.form.detail_register.currency= item.list.currency 
        this.crud.form.detail_register.amount = item.price_simple   
        this.crud.form.detail_register.amount_initial = item.price_simple     

        if(item.list) {
          this.crud.form.detail_register.price_list_id = item.list.id
          this.crud.form.detail_register.price_list = item.list                  
        }      

        this.modal.multipleListPrice.active = false
        setTimeout(() => this.focusQuantity(), 500)
      },
      cancelMultipleListPrice() {
        this.modal.multipleListPrice.active = false
      },          
            
      // ABM MAIN DETAILS
      addItem() {      
        // cantidad
        if (this.crud.form.detail_register.quantity == undefined || this.crud.form.detail_register.quantity.toString() == '' || parseFloat(this.crud.form.detail_register.quantity)<=0) {
          this.$awn.alert('La cantidad debe ser mayor a cero')          
          return false
        }
          
        // amount
        if(this.crud.form.detail_register.amount == undefined || this.crud.form.detail_register.amount.toString() == '') {
          this.crud.form.detail_register.amount = 0
        } else {
          if (parseFloat(this.crud.form.detail_register.amount)<0) {                   
            this.$awn.alert('El precio no puede ser menor a cero')          
            return false          
          }
        }

        // descuento
        if(this.crud.form.detail_register.discount == undefined || this.crud.form.detail_register.discount.toString() == '') {
          this.crud.form.detail_register.discount = 0
        } else {
          if (parseFloat(this.crud.form.detail_register.discount)<0) {      
            this.$awn.alert('El descuento no puede ser menor a cero')          
            return false          
          }
        }
        
        // producto compuesto
        if(!this.crud.form.detail_register.productCompound) {
          this.$awn.alert('No se cargó el producto')          
          return false
        }      
        
        // stock
        if(!this.validStockItem()) {
          this.$awn.alert('Stock Insuficiente') 
          return false
        }

        // duplicado
        if(this.validItemDuplicated) {
          if(!this.validDuplicatedItem()) {
            this.$awn.alert('Item Duplicado') 
            return false          
          }
        }

        // validar condicion de iva
        if(this.crud.form.detail_register.productCompound && !this.crud.form.detail_register.productCompound.iva_conditions_id) {
            this.$awn.alert('No se cargó Alícuota de IVA para el producto compuesto')
            return false        
        }        

        var arrItem = { 
          productCompound: this.crud.form.detail_register.productCompound,
          quantity: parseFloat(this.crud.form.detail_register.quantity),
          quantityOld: parseFloat(this.crud.form.detail_register.quantityOld),
          currency: this.crud.form.detail_register.currency,
          amount: parseFloat(this.crud.form.detail_register.amount),
          discount: parseFloat(this.crud.form.detail_register.discount),
          unit_measurement: this.crud.form.detail_register.unit_measurement,
          price_list: this.crud.form.detail_register.price_list
        }

        this.crud.form.detail.push(arrItem)
        this.$emit('load-detail', this.crud.form.detail)
        
        this.crud.form.detail_register.forceRenderSelectProduct = 0
        this.loadProductsCompound(null)                                    
        
        this.crud.form.detail_register.button.editing = false
      },
      editItem (item, index) {    
        this.crud.form.detail_register.editing = true
        this.crud.form.detail_register.quantity = item.quantity
        this.crud.form.detail_register.quantityOld = item.quantityOld
        this.crud.form.detail_register.discount = item.discount        
        this.crud.form.detail_register.price_list = item.price_list

        this.crud.form.detail_register.currency = item.price_list.currency 
        this.crud.form.detail_register.amount = item.amount   
        this.crud.form.detail_register.amount_initial = item.amount
        this.crud.form.detail_register.unit_measurement = item.unit_measurement
        this.crud.form.detail_register.forceRenderPrice++
        
        if(this.editPrice) {
          this.editing.status = true
          this.editing.price = item.amount
          this.editing.unit_measurement = item.unit_measurement
        } 

        this.crud.form.detail_register.productCompound_id = item.productCompound.id
        this.crud.form.detail_register.forceRenderSelectProduct = item.productCompound.id    
        
        this.crud.form.detail_register.editing = false
        
        this.crud.form.detail_register.button.title = "Editar Item"
        this.crud.form.detail_register.button.icon = "fa fa-save"
        this.crud.form.detail_register.button.variant = "warning"
        this.crud.form.detail_register.button.editing = true
                     
        this.crud.form.detail.splice(index, 1)
        this.$emit('load-detail', this.crud.form.detail)
      },
      deleteItem (index) {
        this.crud.form.detail.splice(index, 1)
        this.$emit('load-detail', this.crud.form.detail)
      },

      // CALCULA DISCOUNT
      getRegDiscount(item) {        
        var totalDiscount = 0
        if(parseFloat(item.discount) > 0) {
          totalDiscount = parseFloat(item.quantity) * (( parseFloat(item.amount) * parseFloat(item.discount) ) / 100)
        }        
        return totalDiscount
      },
      getRegSubTotals(item) {
        var subtotal = parseFloat(item.quantity) * parseFloat(item.amount)
        return subtotal
      },       
      getRegTotals(item) {
        var total = 0
        if(parseFloat(item.discount) > 0) {
          var discount = (parseFloat(item.amount) * parseFloat(item.discount)) / 100
          var amount = parseFloat(item.amount) - parseFloat(discount)

          total = parseFloat(item.quantity) * parseFloat(amount)
        } else {
          total = parseFloat(item.quantity) * parseFloat(item.amount)
        }
        return total
      },      
      getDetailItemAliquotIva(item) {
        var product = item && item.productCompound
        if(!product) return 0
        if(product.amount && product.amount.aliquot_iva !== undefined) return product.amount.aliquot_iva
        var ivaCondition = product.iva_conditions || product.iva_condition || product.IvaConditions || product.IvaCondition
        if(ivaCondition && ivaCondition.aliquot !== undefined) return ivaCondition.aliquot
        var condition = this.ivaConditions.find(value => value.id == product.iva_conditions_id)
        return condition ? condition.aliquot : 0
      },
      hasDetailItemIva(item) {
        return parseFloat(this.getDetailItemAliquotIva(item)) > 0
      },
      getDetailIvaAmount(item) {
        return (parseFloat(item && item.amount) || 0) * (parseFloat(this.getDetailItemAliquotIva(item)) || 0) / 100
      },
      getDetailUnitDiscount(item) {
        return (parseFloat(item && item.amount) || 0) * (parseFloat(item && item.discount) || 0) / 100
      },
      getDetailUnitFinal(item) {
        return (parseFloat(item && item.amount) || 0) - this.getDetailUnitDiscount(item)
      },
      formatDetailPrice(item, amount) {
        if(!item || !item.currency) return ''
        var displayedAmount = parseFloat(amount || 0) * (1 + (parseFloat(this.getDetailItemAliquotIva(item)) || 0) / 100)
        return Intl.NumberFormat('es-AR', {style:'currency', currency:item.currency.code}).format(displayedAmount)
      },
      formatDetailNetPrice(item, amount) {
        return Intl.NumberFormat('es-AR', {style:'currency', currency:item.currency.code}).format(amount)
      },
      getDetailQuantityLabel(item) {
        var quantity = parseFloat(item.quantity || 0).toFixed(2)
        return quantity + (item.unit_measurement ? ' ' + item.unit_measurement.reference : '')
      },

      // VALIDA STOCK
      validStockItem() {        
        var status = true        
        if(this.validStock) {             
          if(this.crud.form.editOrder) {
            if(this.crud.form.detail_register.productCompound) {              
              
              let stockProduct = 0
              if(this.moduleDepositActive) {
                stockProduct = parseFloat(this.crud.form.detail_register.productCompound.stock)
              } else {
                stockProduct = parseFloat(this.crud.form.detail_register.productCompound.stock) + parseFloat(this.crud.form.detail_register.quantityOld)
              }

              if(this.crud.form.detail_register.quantity > stockProduct) {          
                this.crud.form.detail_register.quantity = stockProduct              
                var status = false
              }
            }
          } else {
            if(this.crud.form.detail_register.productCompound) {
              let stockProduct = parseFloat(this.crud.form.detail_register.productCompound.stock) 
              if(this.crud.form.detail_register.quantity >  stockProduct) {          
                this.crud.form.detail_register.quantity = stockProduct
                var status = false
              }
            }
          }
        }
        return status
      },  

      // VALID DUPLICATED
      validDuplicatedItem() {
        var item = this.crud.form.detail_register.productCompound
        var status = true
        if(this.crud.form.detail) {
          this.crud.form.detail.forEach(element => {                                                
            if(element.productCompound.id == item.id) {
              status = false
            }                         
          });
        }
        return status
      },                
    }
  }
</script>
<style>
  .crud-order-table-detail {
    overflow: auto;
    max-height: 350px;    
    min-height: 100px;    
  }
  .block-product-add {
    background: white;
    filter: brightness(0.4);
    border-radius: 15px;
    padding-top: 10px;
    pointer-events: none;
    opacity: 0.5;
  }
  .block-product-add-div {
    position: absolute;
    text-align: center;
    margin-top: 20px;    
  }
  .crud-new-orders-button-add {
    margin-top: 29px;
  }  
  @media (max-width: 767.98px) {
    #container_detail_product_compound_select > div > .form-group {
      margin-bottom: 0;
    }
    .detail-product-compound-pricing-fields {
      margin-top: 12px;
    }
    .detail-product-compound-pricing-fields > .row > [class*="col-"] + [class*="col-"] {
      margin-top: 12px;
    }
    .crud-new-orders-button-add {
      width: 100%;
      margin-top: 8px;
    }
    .crud-new-orders-button-add .btn {
      width: 100%;
    }
  }
  .curd-detail-product-select-unit-measurement {
    font-size: 10px !important;
    padding-left: 3px !important;
    padding-right: 3px !important;
  }
  .curd-detail-product-select-unit-measurement button {
    font-size: 10px;
    padding-left: 3px;
    padding-right: 3px;
  }
  .crud-detail-product-prepend-amount .input-group-prepend .input-group-text {
    padding-left: 3px !important;
    padding-right: 3px !important;    
  }
  .crud-detail-product-append-discount .input-group-append .input-group-text {
    padding-left: 3px !important;
    padding-right: 3px !important;    
  }  
  .detail-discount-rate {
    display: inline-block;
    margin-right: 4px;
    color: var(--app-color-text-muted);
    font-size: 10px;
    font-weight: var(--app-font-semibold);
    vertical-align: baseline;
  }
  .detail-discount-rate--info {
    cursor: pointer;
    text-decoration: underline dotted;
    text-underline-offset: 2px;
  }
  .detail-discount-popover {
    min-width: 245px;
    border: 1px solid var(--app-color-border) !important;
    border-radius: 6px;
    box-shadow: var(--app-shadow-sm);
  }
  .detail-discount-popover .popover-body {
    padding: 7px 10px;
    color: var(--app-color-text-secondary);
    font-size: 11px;
  }
  .detail-discount-popover__row {
    display: grid;
    grid-template-columns: 1fr auto;
    gap: 16px;
    align-items: baseline;
    padding: 3px 0;
  }
  .detail-discount-popover__row + .detail-discount-popover__row {
    border-top: 1px solid var(--app-color-border);
  }
  .detail-discount-popover__section {
    margin-top: 6px;
    padding-top: 6px;
    border-top: 1px solid var(--app-color-border);
  }
  .detail-discount-popover__section-title {
    margin-bottom: 2px;
    color: var(--app-color-text-secondary);
    font-size: 10px;
    font-weight: var(--app-font-semibold);
    letter-spacing: 0.03em;
    text-transform: uppercase;
  }
  .detail-discount-popover__row strong {
    color: var(--app-color-text);
    font-weight: var(--app-font-semibold);
    text-align: right;
    white-space: nowrap;
  }
  .detail-discount-popover__iva {
    display: inline-block;
    margin-left: 3px;
    padding: 1px 4px;
    border-radius: 8px;
    background: var(--app-color-primary-soft);
    color: var(--app-color-primary);
    font-size: 9px;
    font-weight: var(--app-font-semibold);
    vertical-align: 1px;
  }

  #container_detail_product_compound_select .popover-body {
    padding: 8px 10px;
  }
  .detail-product-popover-list__row {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 12px;
    padding: 4px 0;
  }
  .detail-product-popover-list__row + .detail-product-popover-list__row {
    border-top: 1px solid var(--app-color-border);
  }
  .detail-product-popover-list__label {
    color: var(--app-color-text-secondary);
    font-size: 11px;
    font-weight: var(--app-font-semibold);
    text-transform: uppercase;
    letter-spacing: 0.02em;
    flex: 1 1 auto;
    min-width: 0;
  }
  .detail-product-popover-list__value {
    font-weight: var(--app-font-semibold);
    color: var(--app-color-text);
    white-space: nowrap;
    flex: 0 0 auto;
  }
</style>
